import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faFilePdf,
	faChartPie,
	faScroll,
	faFileArrowDown,
	faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import api from '@/helpers/fetch'

library.add(
	faFilePdf,
	faChartPie,
	faScroll,
	faFileArrowDown,
	faTriangleExclamation,
)

@Component({
	components: {
		Loader,
	},
})
export default class Home extends Vue {
	groups = [] as Array<any>
	loading = false

	decisionColors = {
		Deferida: 'background-green',
		'Parcialmente deferida': 'background-yellow',
		Indeferida: 'background-red',
		Desistência: 'background-purple',
		'Acórdão provido': 'background-green',
		'Acórdão parcialmente provido': 'background-yellow',
		'Acórdão não provido': 'background-red',
		'Totalmente procedente': 'background-green',
		'Parcialmente procedente': 'background-yellow',
		Improcedente: 'background-red',
		Sim: 'background-green',
		Não: 'background-red',
		'N/A': 'text-muted',
	}

	fieldHumanNames = {
		preDistributionCredit: 'Crédito pré distribuição',
		feePercentage: 'Porcentagem de honorários',
		feeAmount: 'Valor de honorários',
		decisionDate: 'Data de decisão',
		calculationMonths: 'Meses de cálculo',
		extraMonths: 'Meses extras',
		postFavorableDecisionMonths: 'Meses pós decisão favorável',
		postDistributionMonthlyCredit: 'Crédito pós distribuição mensal',
		postDecisionAmount: 'Valor pós decisão',
		postDistributionTotalCredit: 'Crédito pós distribuição total',
		totalBalance: 'Saldo total',
	}

	async mounted() {
		this.loading = true
		const res = await api.get('/api/my-account/groups')

		this.loading = false
		if (res.ok) {
			this.groups.push(...res.data)

			this.groups.forEach((group) => {
				const subjectsByName = {}
				group.numberOfSubjects = 0
				group.totalBalanceSum = 0
				group.trials.forEach((trial) => {
					const subjects = trial.subjects

					subjects.forEach((subject) => {
						const name = subject.name
						subjectsByName[name] = subjectsByName[name] || true
					})

					if (trial.checkingAccounts[0].visibleToClient) {
						group.totalBalanceSum +=
							trial.checkingAccounts[0].totalBalance
					}
				})

				group.numberOfSubjects = Object.keys(subjectsByName).length
			})
		}
	}

	formatDate(date) {
		return date.split('-').reverse().join('/')
	}

	async downloadFile($event, file) {
		$event.preventDefault()

		const googleDriveId = file.googleDriveId
		const res = await fetch(
			'/api/decision-files/download?googleDriveId=' + googleDriveId,
			{
				headers: {
					Accept: 'application/pdf',
					'Content-Type': 'application/pdf',
				},
				method: 'GET',
				credentials: 'include',
			},
		)

		const headers = [...res.headers]
		const contentDispositionHeader = headers.find(
			(array) => array[0] === 'content-disposition',
		)
		if (contentDispositionHeader) {
			const fileName = contentDispositionHeader[1].replace(
				'attachment; filename=',
				'',
			)

			const blob = await res.blob()
			const newBlob = new Blob([blob])
			const blobUrl = window.URL.createObjectURL(newBlob)

			const link: any = document.createElement('a')
			link.href = blobUrl
			link.setAttribute('download', fileName)
			document.body.appendChild(link)

			if (link) {
				link.click()
				link.parentNode.removeChild(link)
				window.URL.revokeObjectURL(blobUrl)
			}
		}
	}

	formatNumber = formatNumber

	isBlankOrHidden(decision) {
		if (!decision) return true
		decision = decision.toLowerCase()
		return decision === 'oculto' || decision === 'em branco'
	}

	getLastDecision(trial) {
		if (!this.isBlankOrHidden(trial.decisionHabilitacaoDeCredito)) {
			return trial.decisionHabilitacaoDeCredito
		} else if (!this.isBlankOrHidden(trial.decisionTransitoEmJulgado)) {
			return trial.decisionTransitoEmJulgado
		} else if (!this.isBlankOrHidden(trial.decisionStf)) {
			return trial.decisionStf
		} else if (!this.isBlankOrHidden(trial.decisionStj)) {
			return trial.decisionStj
		} else if (!this.isBlankOrHidden(trial.decisionTj)) {
			return trial.decisionTj
		} else if (!this.isBlankOrHidden(trial.decisionTrf)) {
			return trial.decisionTrf
		} else if (!this.isBlankOrHidden(trial.decisionSentenca)) {
			return trial.decisionSentenca
		} else if (!this.isBlankOrHidden(trial.decisionLiminar)) {
			return trial.decisionLiminar
		} else return null
	}

	getLastDecisionInstance(trial) {
		if (!this.isBlankOrHidden(trial.decisionHabilitacaoDeCredito)) {
			return 'Habilitação de Crédito'
		} else if (!this.isBlankOrHidden(trial.decisionTransitoEmJulgado)) {
			return 'Trânsito Em Julgado'
		} else if (!this.isBlankOrHidden(trial.decisionStf)) {
			return 'STF'
		} else if (!this.isBlankOrHidden(trial.decisionStj)) {
			return 'STJ'
		} else if (!this.isBlankOrHidden(trial.decisionTj)) {
			return 'TJ'
		} else if (!this.isBlankOrHidden(trial.decisionTrf)) {
			return 'TRF'
		} else if (!this.isBlankOrHidden(trial.decisionSentenca)) {
			return 'Sentença'
		} else if (!this.isBlankOrHidden(trial.decisionLiminar)) {
			return 'Liminar'
		} else return null
	}
}

function formatNumber(num) {
	if (!num && num !== 0) {
		return num
	}

	const numArr = num.toString().split('.')
	const whole = numArr[0].split('').reverse()

	let fractional = numArr?.[1] || '00'
	if (fractional?.length === 1) {
		fractional += '0'
	}

	const result: string[] = []

	whole.forEach((char, i) => {
		result.push(char)

		if ((i + 1) % 3 === 0) {
			result.push('.')
		}
	})

	if (result[result.length - 1] === '.') {
		result.pop()
	}

	if (fractional && fractional.length > 2) {
		const third = parseInt(fractional[2], 10)
		let second = parseInt(fractional[1], 10)
		if (third > 4) {
			second++
		}

		fractional = fractional[0] + second
	}

	const resultString = result.reverse().join('') + ',' + fractional

	return resultString
}
